//login-model.js


import { Model } from 'backbone';
import Immutable from 'immutable';

class LoginModel extends Model {

    initialize() {
        // console.log('LoginModel initialized');
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default LoginModel;
